import React from "react";
const Loader: React.FC = () => {
    return (
        <div id="loader-wrapper" >
            <div className="circle">
                <h6>Loading...</h6>
            </div>
        </div>
    )
}

export default Loader;

